export default function PHP_array_map() {
  return (
    <div>
      <h1>PHP_array_map</h1>
    </div>
  );
}
